import * as React from 'react'

import { SCREENS } from './workflow'

const init = Object.keys(SCREENS) as AdminUserStep[]

const useWorkflow = (form: AdminUserForm, edit?: AdminUserStep) => {
  const [workflow, setWorkflow] = React.useState(init)

  React.useEffect(() => {
    const next = init

    // add rules on workflow
    // every rule defined workflow cut

    // *************************************************
    //                  form rules
    // *************************************************
    const ViparisRule = form.typeUtilisateur === 'VIPARIS' ? ['site', 'manif'] : []
    const OrganisateurRule = form.typeUtilisateur === 'ORGANISATEUR' ? ['site_viparis', 'site'] : []
    const PrestataireRule = form.typeUtilisateur === 'PRESTATAIRE' ? ['site_viparis', 'manif'] : []

    // *************************************************
    //                  content rules
    // *************************************************

    // keep only one screen for update
    const PartialUpdateRule = edit ? ['info', 'scope', 'site_viparis', 'site', 'manif'].filter((s) => s !== edit) : []

    //combined every rules
    const wf = next
      .filter((w) => !ViparisRule.includes(w))
      .filter((w) => !OrganisateurRule.includes(w))
      .filter((w) => !PrestataireRule.includes(w))
      .filter((w) => !PartialUpdateRule.includes(w))

    setWorkflow(wf)
  }, [form, edit])

  return [workflow] as const
}

export default useWorkflow
